import { render, staticRenderFns } from "./RipaSelect.vue?vue&type=template&id=24df0b72"
import script from "./RipaSelect.vue?vue&type=script&lang=js"
export * from "./RipaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports